import { Alert } from '@creditornot/cb-alert';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

const AlertWrapper = styled.div`
  padding: 16px;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

export const VenueIsLinkedAlert = () => {
  const intl = useIntl();
  return (
    <AlertWrapper>
      <Alert
        variant="warning"
        size="medium"
        title={intl.formatMessage({ id: 'listing-manager.selections.venue-editor.classic.alert.title' })}
      >
        <FormattedMessage id="listing-manager.selections.venue-editor.classic.alert.message" />
      </Alert>
    </AlertWrapper>
  );
};
